import { render, staticRenderFns } from "./OfferCarouselItemBottom.vue?vue&type=template&id=4afd4e2c&scoped=true&"
import script from "./OfferCarouselItemBottom.vue?vue&type=script&lang=js&"
export * from "./OfferCarouselItemBottom.vue?vue&type=script&lang=js&"
import style0 from "./OfferCarouselItemBottom.vue?vue&type=style&index=0&id=4afd4e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd4e2c",
  null
  
)

export default component.exports